import { PolicyType } from 'store/modules/Policies/types';
//import { unFormatCurrency, unFormatPercent, formatCurrency } from 'utils';
import { PolicyFormType } from './InitialCharge';

// TODO DEFINE VALIDATION

interface ValuesType {
  payment_type: 'lump_sum' | 'regular_contribution';
  charge_in_type: 'percentage' | 'monetary';
  amount: string;
  payment_method: 'paid_directly' | 'from_policy';
  percentage: string;
  policies: PolicyFormType[];
}

type PolicyReducedType = {
  charge_allocation_amount: number | string;
};

export const validate = (
  values: ValuesType,
  activePolicy: PolicyType | null
) => {
  if (!activePolicy) return {};
  const errors: any = {};

  // NOTE do not remove

  // const {
  //   charge_percentage,
  //   payment_type,
  //   charge_in_type,
  //   amount,
  //   payment_method,
  //   policies
  // } = values;

  // const { fund_value } = activePolicy;

  // if (payment_method === 'from_policy') {
  //   const chargeValue =
  //     charge_in_type === 'percentage'
  //       ? Number(unFormatPercent(charge_percentage) * Number(fund_value)) / 100
  //       : Number(unFormatCurrency(amount));

  //   const appliedCharge = [...policies]
  //     .filter(policy => policy.isChecked)
  //     .reduce(
  //       (prev: PolicyFormType, next: PolicyFormType) => {
  //         const prevCharge = Number(
  //           unFormatCurrency(prev.charge_allocation_amount)
  //         );
  //         const nextCharge = Number(
  //           unFormatCurrency(next.charge_allocation_amount)
  //         );

  //         return { ...next, charge_allocation_amount: prevCharge + nextCharge };
  //       },
  //       {
  //         charge_allocation_amount: 0,
  //         fund_value: '',
  //         id: 0,
  //         display_name: '',
  //         isChecked: false
  //       }
  //     ).charge_allocation_amount;

  //   if (chargeValue !== appliedCharge) {
  //     errors.total = chargeValue;
  //   }
  // }

  return errors;
};
